import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { BenefitRulesService } from '../../../../../services/benefit-rules/benefit-rules.service';
import { BenefitRule, Service } from '../../../../../models/benefit-rule.model';

@Component({
    selector: 'app-edit-benefit-rule-modal',
    templateUrl: './edit-benefit-rule-modal.component.html',
    styleUrls: ['./edit-benefit-rule-modal.component.scss'],
    standalone: false
})
export class EditBenefitRuleModalComponent implements OnInit {
  @Input() rule!: BenefitRule;
  
  loading = false;
  loadingServices = false;
  services: Service[] = [];

  ruleForm = new FormGroup({
    benefit_service: new FormControl<string>('', [Validators.required]),
    trap_quantity: new FormControl<number>(0, [Validators.required, Validators.min(0)]),
    capacity: new FormControl<number>(0, [Validators.required, Validators.min(0)]),
    restaurant_count: new FormControl<number>(0, [Validators.required, Validators.min(0)]),
    description: new FormControl<string>('')
  });

  constructor(
    public activeModal: NgbActiveModal,
    private benefitRulesService: BenefitRulesService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.loadServices();
    this.populateForm();
  }

  loadServices(): void {
    this.loadingServices = true;
    this.benefitRulesService.getServices().subscribe({
      next: (response) => {
        this.services = response.services || [];
        this.loadingServices = false;
      },
      error: (error) => {
        console.error('Error loading services:', error);
        this.toastr.error('Error loading services');
        this.loadingServices = false;
      }
    });
  }

  populateForm(): void {
    if (this.rule) {
      this.ruleForm.patchValue({
        benefit_service: this.rule.benefit_service?._id,
        trap_quantity: this.rule.trap_quantity,
        capacity: this.rule.capacity,
        restaurant_count: this.rule.restaurant_count,
        description: this.rule.description || ''
      });
      this.benefitServiceControl.disable();
    }
  }

  onSubmit(): void {
    if (this.ruleForm.invalid) {
      this.ruleForm.markAllAsTouched();
      this.toastr.warning('Please fill all required fields');
      return;
    }

    const ruleId = this.rule._id || this.rule.id;
    if (!ruleId) {
      this.toastr.error('Rule ID is missing');
      return;
    }

    this.loading = true;
    const ruleData = this.ruleForm.getRawValue();
    
    this.benefitRulesService.updateBenefitRule(ruleId, ruleData as any).subscribe({
      next: (response) => {
        this.toastr.success(response.msg || 'Benefit rule updated successfully');
        this.activeModal.close(true);
      },
      error: (error) => {
        this.toastr.error(error?.error?.msg || 'Error updating benefit rule');
        this.loading = false;
      }
    });
  }

  close(): void {
    this.activeModal.dismiss(false);
  }

  // Getters for form controls
  get benefitServiceControl(): FormControl { return this.ruleForm.get('benefit_service') as FormControl; }
  get trapQuantityControl(): FormControl { return this.ruleForm.get('trap_quantity') as FormControl; }
  get capacityControl(): FormControl { return this.ruleForm.get('capacity') as FormControl; }
  get restaurantCountControl(): FormControl { return this.ruleForm.get('restaurant_count') as FormControl; }
  get descriptionControl(): FormControl { return this.ruleForm.get('description') as FormControl; }
}
